<template>
  <b-alert :show="errors.length > 0" variant="danger" class="app-error-view">
    <ul class="error-list">
      <li class="error-item" v-for="(error) in errors" v-bind:key="error.__uuid">{{error.message}}</li>
    </ul>
  </b-alert>
</template>
<script>
import MessageBase from './MessageBase'
import { BAlert } from 'bootstrap-vue'

export default {
  name: 'ErrorModal',
  extends: MessageBase,
  components: {
    BAlert
  }
}
</script>
